import { RelatedDataset } from 'hooks/data/datasets/types';

const filterDataType = (data?: RelatedDataset[], dataType?: string) => {
  return data?.filter((item) => item.related_dataset_type === dataType) ?? [];
};

export const systemModelDisplayNames: Record<string, string> = {
  cutoff: 'Cut-off',
  EN15804: 'EN15804',
  apos: 'APOS',
  consequential: 'Consequential',
  undefined: 'Undefined',
};

export const systemModelSubtitles: Record<string, string> = {
  cutoff: 'Most commonly used model with burden-free recyclables. Beginner-friendly',
  EN15804: 'Required for construction product EPDs',
  apos: 'Burdens shared between waste producers and recovered materials',
  consequential: 'For decision-making about future changes',
  undefined: 'For advanced users creating custom models',
};

export const buildDropdownData = (data: RelatedDataset[] | undefined) => [
  {
    label: 'Version',
    options: filterDataType(data, 'version'),
    gridProps: { xs: 12, sm: 2, md: 1 },
    tooltip:
      'A new version of the ecoinvent database is published every year, with expanded sectorial and geographical coverage.',
    linkText: 'Learn more about each version release',
    linkHref: 'https://support.ecoinvent.org/database#releases',
  },
  {
    label: 'System model',
    options: filterDataType(data, 'system_model'),
    gridProps: { xs: 12, sm: 3, md: 2 },
    tooltip:
      'System models determine how environmental impacts are distributed between producers and consumers of materials, especially for recycling and waste treatment. Choose based on your study goal.',
    linkText: 'Learn more about each system model',
    linkHref: 'https://support.ecoinvent.org/system-models',
    useCustomDropdown: true,
  },
  {
    label: 'Activity name',
    options: filterDataType(data, 'activity'),
    gridProps: { xs: 12, sm: 5, md: 4 },
  },
  {
    label: 'Geography',
    options: filterDataType(data, 'geography'),
    gridProps: { xs: 12, sm: 6, md: 2 },
  },
  {
    label: 'Reference product',
    options: filterDataType(data, 'product'),
    gridProps: { xs: 12, sm: 6, md: 3 },
  },
];
